import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { Toast } from '../CustomSwal';
import { createGroceryV2Favorite, deleteGroceryV2Favorite, loadGroceryV2Favorites } from '../../redux-components/actions/groceryV2Actions';

const GroceryV2Item = ({ id, text, onRemove, onEdit, onCheck, isChecked, editMode, onFavoriteToggle }) => {
    const dispatch = useDispatch();
    const [inputText, setInputText] = useState(text);
    const [liked, setLiked] = useState(false);

    const groceryV2FavoritesGet = useSelector(state => state.groceryV2FavoritesGet);
    const { groceryV2Favorites } = groceryV2FavoritesGet;

    useEffect(() => {
        setInputText(text);
    }, [text]);

    useEffect(() => {
        if (!groceryV2FavoritesGet.loading && groceryV2Favorites?.favorites) {
            if (groceryV2Favorites.favorites.indexOf(text) > -1) {
                setLiked(true);
            } else {
                setLiked(false);
            }
        }
    }, [groceryV2Favorites, groceryV2FavoritesGet, text]);

    useEffect(() => {
        if (inputText !== text) {
            const debounce = setTimeout(() => {
                onEdit(inputText);
                Toast.fire({
                    icon: 'success',
                    title: 'Item updated'
                });
            }, 1000);
            
            return () => clearTimeout(debounce);
        }
    }, [inputText, text, onEdit]);

    const favoriteHandler = async () => {
        try {
            if (liked) {
                // Optimistic update
                setLiked(false);
                await dispatch(deleteGroceryV2Favorite(text));
                // Reload favorites in background after delay
                setTimeout(() => {
                    dispatch(loadGroceryV2Favorites());
                }, 200);
                await Toast.fire({
                    icon: 'success',
                    title: 'Item removed from favorites'
                });
            } else {
                // Optimistic update
                setLiked(true);
                await dispatch(createGroceryV2Favorite(text));
                // Reload favorites in background after delay
                setTimeout(() => {
                    dispatch(loadGroceryV2Favorites());
                }, 200);
                await Toast.fire({
                    icon: 'success',
                    title: 'Item added to favorites'
                });
            }
        } catch (e) {
            // Revert optimistic update on error
            setLiked(!liked);
            await Toast.fire({
                icon: 'error',
                title: e.message
            });
        }
    };

    return (
    <div className={`flex space-x-2 touch-manipulation rounded-md flex-row p-4 text-black w-full content-center justify-center items-center ${isChecked ? 'bg-green-100' : 'bg-gray-100'} active:bg-red-200`}>
        <div onClick={favoriteHandler}
             className={'flex items-center h-8 w-8 justify-center text-red-500 cursor-pointer hover:text-red-300'}>
            <FontAwesomeIcon icon={liked ? 'fas fa-heart' : 'far fa-heart'} size={'xl'}/>
        </div>
        <div className={'flex items-center h-8 w-8 justify-center text-gray-500 cursor-grab active:cursor-grabbing drag-handle'}>
            <FontAwesomeIcon icon={'fas fa-grip-vertical'} size={'lg'}/>
        </div>
        {editMode && (
            <div onClick={onRemove}
                 className={'flex items-center h-8 w-8 justify-center text-red-500 cursor-pointer hover:text-red-300'}>
                <FontAwesomeIcon icon={'fas fa-trash'} size={'sm'}/>
            </div>
        )}
        <input 
            onChange={(e) => setInputText(e.target.value)} 
            type={'text'} 
            value={inputText}
            className={`flex flex-grow text-center bg-transparent placeholder-black content-center items-center justify-center w-full p-2 overflow-auto max-h-36 empty-scroll ${isChecked ? 'line-through text-gray-500' : ''}`}
            onPointerDown={(e) => e.stopPropagation()}
            onTouchStart={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
        />
        <div onClick={(e) => {
            e.stopPropagation();
            onCheck();
        }}
             className={`${isChecked ? "text-white" : "text-black hover:text-zinc-800"} z-50 flex items-center h-8 w-8 justify-center bg-black hover:bg-zinc-800 cursor-pointer p-2 rounded-md`}>
            <FontAwesomeIcon icon="fas fa-check"/>
        </div>
    </div>
    );
};

export default GroceryV2Item;
